import React from 'react'

import MaritimePartnersPage from '../../../react4xp/components/MaritimePartnersPage'

function MaritimePartnersPart({ title, intro, maritimePartners, operations, maps, operationsHeader, mapPlaceholder, searchPlaceholder, tabsText, resultsPerPage, productTypeHeader, productTypes }) {
	return (
		<MaritimePartnersPage
			mapPlaceholder={mapPlaceholder}
			topPart={{
				title: title,
				intro: `<p>${intro}</p>`
			}}
			searchPlaceholder={searchPlaceholder}
			operations={{
				title: operationsHeader,
				items: operations.map(operation => ({ title: operation }))
			}}
			partners={maritimePartners}
			maps={maps}
			tabsText={tabsText}
			resultsPerPage={resultsPerPage}
			productType={(productTypes.length > 0) ? {
				title: productTypeHeader,
				items: productTypes.map(productType => ({ title: productType }))
			} : undefined}
		/>
	)
}

export default (props) => <MaritimePartnersPart {...props} />
